module.exports = __webpack_public_path__ + "static/img/holiday-cherry_th.9cd616e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/cans/holiday-cherry_th.png
// module id = heNl
// module chunks = 0